import React from 'react';

import { Header } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import Picture from 'components/picture';
import { Box, BoxProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { primitive, spacing } from 'styles/constants';

export const ListContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.listContainer, style] });

export const StyledTileContainer = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();
  return React.createElement(Box, {
    ...props,
    style: [styles.tileContainer, isDesktop && styles.tileContainerDesktop, style],
  });
};

export const TileImage = Picture.withConfig({
  maxWidth: { base: '40px', md: '60px' },
  maxHeight: { base: '40px', md: '60px' },
  marginRight: {
    base: 0,
    md: '$6',
  },
});

export const TileTitle = Header.withConfig({
  variant: 'headerThree',
  color: primitive.$bbqBrown,
  margin: 0,
});

const styles = StyleSheet.create({
  listContainer: {
    gap: spacing.$4,
  },
  tileContainer: {
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    borderRadius: 12,
    flexDirection: 'row',
    minHeight: 80,
    padding: spacing.$4,
  },
  tileContainerDesktop: {
    minHeight: 112,
  },
});
